import React from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

import mainPic from '/assets/images/2022aug/bellini_main.png';
import bellini_image01 from '/assets/images/2022aug/bellini_image01.png';
import bellini_image02 from '/assets/images/2022aug/bellini_image02.png';

import ProductTemplate from "./ProductTemplate";

const ProductBellini = () => {

    const belliniInfo = {
        className: "product bellini",
        id: "bellini",
        copy: "誰よりも可愛い私でいたい\nはかなげ絶妙ピンク",
        src: mainPic,
        alt: "PINK BELLINI",
        cardData: [
            {     
                className: "product__group product__group--01", 
                src: bellini_image01,
                alt: "WONDER LIP TINT",
                title: "WONDER LIP TINT",
                price: "1,590 (tax in)",
                text: "ベリーニのような甘くとろける\n垢抜けピンクベージュ",
                url: "https://uchoobeauty.com/products/lip_pinkbellini"
            },
            {
                className: "product__group product__group--02", 
                src: bellini_image02,
                alt: "GLAM EYE SHADOW",
                title: "GLAM EYE SHADOW",
                price: "2,190 (tax in)",
                text: "熟したピーチが上品な\n大人ピンクブラウン",
                url: "https://uchoobeauty.com/products/eye_pinkbellini"
            }
        ]
    }

    return (
        <ProductTemplate {...belliniInfo}/>
    )
}

export default ProductBellini